<template>
    <div class="pt-5">
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <ValidationProvider name="mensaje" rules="required" v-slot="{ errors }">
                <CkEditorComponent v-model="mensaje" id="mensaje"/>
                <span id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
            </ValidationProvider>
            <div class="d-flex justify-content-end pt-3 pb-3">
                <Button type="submit" name="crear" id="crear">Enviar</Button>
            </div>
        </ValidationObserver>
    </div>
</template>


<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';

    export default {
        props: ['incidencia_id'],
        data() {
            return {
                conf: {},
                mensaje: ''
            }
        },
        methods: {
            async submit(){
                const isValid = await this.$refs.observer.validate();
                if (isValid){
                    const params = {
                        filters: {},
                        mensaje: this.mensaje,
                        incidencia_id: this.incidencia_id
                    }
                    this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.create.mensaje'), params).then(res => {
                        this.$toast.success(res.data.message);
                        this.$emit('refresh')
                    })
                }
            }
        },
        components: {
            CkEditorComponent
        }
    }
</script>